import { Base } from "../../framework/base";
import { CompanyMenuItem, ICompanyMenuItem } from "../company/companyMenuItem";
import { IInstantMessageChannelEditItem, InstantMessageChannelEditItem } from "./instantMessageChannelEditItem";

export interface IInstantMessageChannelNew {
    instantMessageChannel: IInstantMessageChannelEditItem;
    companies: ICompanyMenuItem[];
    existingTwoPersonChannelPartnerUserCodes: string[];
}

export class InstantMessageChannelNew implements IInstantMessageChannelNew {
    instantMessageChannel: InstantMessageChannelEditItem;
    companies: CompanyMenuItem[];
    existingTwoPersonChannelPartnerUserCodes: string[];

    constructor();
    constructor(obj: IInstantMessageChannelNew);
    constructor(obj?: any) {
        this.instantMessageChannel = new InstantMessageChannelEditItem(obj ? obj.instantMessageChannel : null);
        this.companies = Base.getTypedArray<CompanyMenuItem>(obj ? obj.companies : null, CompanyMenuItem);
        this.existingTwoPersonChannelPartnerUserCodes = obj && obj.existingTwoPersonChannelPartnerUserCodes || [];
    }
}